import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-status5",
  "use": "icon-user-status5-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-status5\">\n<g id=\"icon-user-status5_icon\" clip-path=\"url(#icon-user-status5_clip0_57_18842)\">\n<path id=\"icon-user-status5_Vector\" d=\"M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 6.60938 2.67656 5.33125 3.49219 4.33125L11.6687 12.5078C10.6687 13.3234 9.39062 13.8125 8 13.8125ZM12.5078 11.6687L4.33125 3.49219C5.33125 2.67656 6.60938 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 9.39062 13.3234 10.6687 12.5078 11.6687Z\" fill=\"#777777\" />\n</g>\n<defs>\n<clipPath id=\"icon-user-status5_clip0_57_18842\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-status5.svg
// module id = NAGo
// module chunks = 103